__turbopack_context__.v({
  "animation-colors": "pPObhW_animation-colors",
  "default": "pPObhW_default",
  "header": "pPObhW_header",
});
